module.exports = __webpack_public_path__ + "12a78af50f9bec7f1097e1781b981e2b.svg";